import FlexPane from './_flex-pane.js'
import SkeletonPart from './_skeleton-part.js'

export default {
  name: 'ApplicationHeaderSkeleton',
  values: {
    container: {
      configSet: FlexPane,
      configValues: {
        style: {
          flexGrow: 0,
          flexDirection: 'column',
          _mobile_height: '48px',
          height: '112px',
          justifyContent: 'center',
          alignItems: 'center',
        },
      },
    },
    navigationBarContainer: {
      configSet: FlexPane,
      configValues: {
        style: {
          _mobile_height: '0px',
          height: '48px',
          width: '100%',
        },
      },
    },
    buttonsContainer: {
      configSet: FlexPane,
      configValues: {
        itemSpacing: '8px',
        style: {
          padding: '0 16px',
          _mobile_padding: '0 8px',
          boxSizing: 'border-box',
          maxWidth: '1440px',
          width: '100%',
          height: '64px',
          _mobile_height: '100%',
          justifyContent: 'end',
          alignItems: 'center',
        },
      },
    },
    buttonSkeleton: {
      configSet: SkeletonPart,
      configValues: {
        style: {
          width: '92px',
          _mobile_width: '64px',
          height: '40px',
        },
      },
    },
  },
  meta: {
    extendable: false,
  },
}
